import axios from "axios";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { baseUrl } from "../helpers/baseUrl";

export async function getListCampaigns(pageNumber) {
  // var tokenStr = localStorage.getItem("jwtTokenSingh");
  // axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/campaign/get-campaign-list/${pageNumber}`
    );
    // console.log("CampaignRes", response);
    return response.data;
  } catch (err) {
    console.log("err", err.response);
    //   if (err.response.status === 400) {
    //     Swal.fire("", err.response.data.error, "error");
    //   } else {
    //     Swal.fire("Something went wrong with server", "Try again later", "error");
    //   }
  }
  // return err.response.data;
}

export async function uploadPost(postData) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.post(`${baseUrl}/post/create-post`, postData);
    // console.log("uploadPost", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function getFeed(pageNumber) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/post/get-followers-post/${pageNumber}`
    );
    // console.log("getFeed", response);
    return response.data;
  } catch (err) {
    console.log("err", err.response);
    return [];
  }
}

export async function getAllVideos(pageNumber) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/post/getallvideo/${pageNumber}`
    );
    // console.log("getAllVideo", response);
    return response.data;
  } catch (err) {
    console.log("err", err.response);
    return [];
  }
}

export async function getNotifications(pageNumber) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/user/notification/list/?pageNumber=${pageNumber}`
    );
    // console.log("getNotifications", response);
    return response.data;
  } catch (err) {
    console.log("err", err.response);
    return [];
  }
}

export async function getNotificationsCountData() {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(`${baseUrl}/user/unread`);
    // console.log("getNotificationsCountData", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function getUserList() {
  // var tokenStr = localStorage.getItem("jwtTokenSingh");
  // axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(`${baseUrl}/user/search-user`);
    // console.log("getUserList", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function postLike(postId) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.put(`${baseUrl}/post/likes`, postId);
    // console.log("postLike", response);
    return response.data;
  } catch (err) {
    console.log("err", err.response);
  }
}

export async function postUnLike(postId) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.put(`${baseUrl}/post/unlike`, postId);
    // console.log("postUnLike", response);
    return response.data;
  } catch (err) {
    console.log("err", err.response);
  }
}

export async function postComment(postComData) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.put(`${baseUrl}/post/comment`, postComData);
    // console.log("postComment", response);
    return response.data;
  } catch (err) {
    console.log("err", err.response);
  }
}

export async function postDelete(deleteData) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.delete(`${baseUrl}/post/delete-post`, {
      data: deleteData,
    });
    // console.log("postDelete", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function countLikes(postId, pageNumber) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/post/count-like/${postId}/${pageNumber}`
    );
    // console.log("countLikes", response);
    return response.data;
  } catch (err) {
    console.log("err", err.response);
  }
}

export async function countComments(postId, pageNumber) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/post/count-comments/${postId}/${pageNumber}`
    );
    // console.log("countComment", response);
    return response.data;
  } catch (err) {
    console.log("err", err.response);
  }
}

export async function listNftByAuctionId(auctionId) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  // var tokenStr =
  //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7ImVtYWlsIjoibGl6YXNhbXN1bjk1QGdtYWlsLmNvbSJ9LCJpYXQiOjE2Njg2ODgxODF9.sq9ITFtBM_opeYzw6w37oaKsqKyc_YHQBRqWdwDWOI8";
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(`${baseUrl}/auctionbyId/${auctionId}`);
    // console.log("listNftByAuctionId", response);
    return response.data;
  } catch (err) {
    console.log("err", err.response);
  }
}

export async function listNftByStatus(pageNumber, status) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  // var tokenStr =
  //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7ImVtYWlsIjoibGl6YXNhbXN1bjk1QGdtYWlsLmNvbSJ9LCJpYXQiOjE2Njg2ODgxODF9.sq9ITFtBM_opeYzw6w37oaKsqKyc_YHQBRqWdwDWOI8";
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/nft/list/status?pageNumber=${pageNumber}&sellingStatus=${status}`
    );
    // console.log("nftByStatus", response);
    return response;
  } catch (err) {
    console.log("err", err);
    return err;
  }
}

export async function listNftStatic(pageNumber) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  // var tokenStr =
  //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7ImVtYWlsIjoibGl6YXNhbXN1bjk1QGdtYWlsLmNvbSJ9LCJpYXQiOjE2Njg2ODgxODF9.sq9ITFtBM_opeYzw6w37oaKsqKyc_YHQBRqWdwDWOI8";
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/nft/list?pageNumber=${pageNumber}`
    );
    // console.log("listNftStaticRes", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
    return err;
  }
}

export async function getUserInfo(username) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(`${baseUrl}/user/get-info/${username}`);
    // console.log("getUserInfo", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function getAccountPost(username, pageNumber) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/post/get-account-post/${username}/${pageNumber}`
    );
    // console.log("getAccountPost", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function getListNftUser(email, pageNumber) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  // var tokenStr =
  //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7ImVtYWlsIjoiZ2F1cmF2YmJoYWRhbmU5NEBnbWFpbC5jb20ifSwiaWF0IjoxNjY5MzczNTc3fQ.kBbJ6XpeCRZeaVuiHRucGbl3d-4PKrr3zV6VsdVfAog";
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/nft/list/user?pageNumber=${pageNumber}&email=${email}`
    );
    // console.log("getListNftUser", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function getFollowing(username, pageNumber) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/user/get-following/${username}/${pageNumber}`
    );
    // console.log("getFollowing", response);
    return response.data;
  } catch (err) {
    console.log("err", err.response);
  }
}

export async function getFollowers(username, pageNumber) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/user/get-followers/${username}/${pageNumber}`
    );
    // console.log("getFollowers", response);
    return response.data;
  } catch (err) {
    console.log("err", err.response);
  }
}

export async function getDefaultSearchUser() {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(`${baseUrl}/user/search-user`);
    // console.log("getDefaultSearchUser", response);
    return response.data;
  } catch (err) {
    console.log("err", err.response);
  }
}

export async function getSearchUser(username) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(`${baseUrl}/user/search-user/${username}`);
    // console.log("getSearchUser", response);
    return response.data;
  } catch (err) {
    console.log("err", err.response);
    return [];
  }
}

export async function updateUser(updateData) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.patch(
      `${baseUrl}/user/update-user`,
      updateData
    );
    // console.log("updateUser", response);
    return response;
  } catch (err) {
    console.log("err", err.response);

    if (err.response.status === 403) {
      toast.warning(`${err.response.data.error}`, {
        style: {
          fontSize: "15px",
        },
      });
    } else {
      toast.error(`Oops something went wrong, please try again`, {
        style: {
          fontSize: "15px",
        },
      });
    }

    return err.response;
  }
}

export async function updateUserBackground(updateData) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.patch(
      `${baseUrl}/user/update-background`,
      updateData
    );
    // console.log("updateUserBackground", response);
    return response;
  } catch (err) {
    console.log("err", err.response);

    if (err.response.status === 403) {
      toast.warning(`${err.response.data.error}`, {
        style: {
          fontSize: "15px",
        },
      });
    } else {
      toast.error(`Oops something went wrong, please try again`, {
        style: {
          fontSize: "15px",
        },
      });
    }

    return err.response;
  }
}

export async function postMetaDataHash(postData) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.post(`${baseUrl}/nft/meta-data`, postData);
    // console.log("postData", response);
    return response.data;
  } catch (err) {
    console.log("postMetaDataHash API Error", err.response);
  }
}

export async function postMint(mintedData) {
  // console.log("mintedData", mintedData);
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.post(`${baseUrl}/nft/past-events`, mintedData);
    // console.log("postMint", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function postBuyNft(buyData) {
  // console.log("buyData", buyData);
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.post(`${baseUrl}/nft/buy`, buyData);
    // console.log("postBuyNft", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function postBidNft(bidData) {
  // console.log("bidData", bidData);
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.post(`${baseUrl}/nft/bid/set`, bidData);
    // console.log("postBidNft", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function checkBidderWalletBal(bidderWalletAddress) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/balance/wallet-address?walletAddress=${bidderWalletAddress}`
    );
    // console.log("checkBidderWalletBal", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function postAcceptBidNft(bidderData) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.post(`${baseUrl}/nft/bid/accept`, bidderData);
    // console.log("acceptBidNft", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function getBidList(auctionId) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/nft/bid/list?auctionID=${auctionId}`
    );
    // console.log("getBidList", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
    return [];
  }
}

export async function getSoldList(auctionId) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/nft/sold/list?auctionID=${auctionId}`
    );
    // console.log("getSoldList", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
    return [];
  }
}

export async function updateUserWalletAddress(walletAddress) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.post(
      `${baseUrl}/user/update-walletAddress`,
      walletAddress
    );
    // console.log("updateUserWalletAddress", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
    return err;
  }
}

export async function auctionCancel(auctionId) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/auction/cancel?auctionID=${auctionId}`
    );
    // console.log("auctionCancel", response);
    return response.data;
  } catch (err) {
    console.log("err", err.response);
  }
}

export async function deleteBid(deleteData) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.post(`${baseUrl}/nft/bid/delete`, deleteData);
    // console.log("deleteBid", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function blockUser(username) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/user/block?username=${username}`
    );
    // console.log("blockUser", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function unBlockUser(username) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/user/unblock?username=${username}`
    );
    // console.log("unBlockUser", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function getShowBlockedUsers() {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(`${baseUrl}/user/block/list`);
    // console.log("blockUser", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function reportPost(reportData) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.post(`${baseUrl}/post/report`, reportData);
    // console.log("reportPost", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function reportUser(username) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/user/report?username=${username}`
    );
    // console.log("reportUser", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    return err.response;
  }
}

export async function getPostById(postId) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(`${baseUrl}/post/postbyid/${postId}`);
    // console.log("getPostById", response);
    return response.data;
  } catch (err) {
    console.log("err", err.response);
  }
}

export async function getNftById(nftId) {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(`${baseUrl}/auctionbyId/${nftId}`);
    // console.log("getNftById", response);
    return response.data;
  } catch (err) {
    console.log("err", err.response);
  }
}

export async function getRewardPointsInfo() {
  var tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(`${baseUrl}/reward/points`);
    // console.log("getNftById", response);
    return response;
  } catch (err) {
    console.log("err", err);
    return err;
  }
}
